import { ref } from 'vue'
import { defineStore } from 'pinia'
import { UsersService, type TUser } from '@/types/generated'

export const useUserStore = defineStore('userStore', () => {
  const user = ref<TUser>()

  async function fetchUser() {
    try {
      const response = await UsersService.usersRetrieve({ uuid: 'current' })
      user.value = response
      return response
    } catch (error) {
      return null
    }
  }

  return {
    user,
    fetchUser
  }
})
